import { AgGridVue } from 'ag-grid-vue'
import ToolTipRenderer from '@/components/DynamicComponents/Renderers/tooltipRenderer'
import HeaderRenderer from '@/components/DynamicComponents/Renderers/headerRenderer'
import EstimateInfoRenderer from '@/components/DynamicComponents/Renderers/estimateInfoRenderer'
import EstimateMethodRenderer from '@/components/DynamicComponents/Renderers/estimateMethodRenderer'
import _ from 'lodash'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
  },
  props: ['type', 'list'],
  data() {
    return {
      width: '100%',
      gridOptions: null,
      data: [],
      loading: true,
      columnDefs: [],
      height: '20rem',
      count: 0,
    }
  },
  beforeMount() {
    this.data = [...this.list]
    this.loadingConfig()
  },
  methods: {
    loadingConfig() {
      this.gridOptions = {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 50,
        rowHeight: 50,
        suppressRowClickSelection: true,
        singleClickEdit: false,
        stopEditingWhenGridLosesFocus: true,
        tooltipShowDelay: 0,
        suppressContextMenu: true,
        defaultColDef: {
          sortable: false,
          suppressMovable: true,
          resizable: false,
          editable: false,
          filter: false,
          menuTabs: [],
        },
      }
      this.frameworkComponents = {
        toolTipRenderer: ToolTipRenderer,
        headerRenderer: HeaderRenderer,
        estimateInfoRenderer: EstimateInfoRenderer,
        estimateMethodRenderer: EstimateMethodRenderer,
      }
      this.columnDefs = [
        {
          headerName: 'Estimate Group',
          field: 'estimateGroupName',
          headerTooltip: 'Estimate Group',
          headerClass: 'header-left',
          cellStyle: { textAlign: 'left' },
          width: 150,
          wrapText: true,
          resizable: true,
          cellRenderer: 'toolTipRenderer',
          pinned: 'left',
        },
        {
          headerName: 'Estimate Method',
          field: 'estimateMethod',
          headerTooltip: 'Estimate Method',
          headerClass: 'header-left',
          cellStyle: { textAlign: 'left' },
          cellRendererParams: {
            name: 'estimateMethod',
          },
          width: 150,
          wrapText: false,
          cellRenderer: 'estimateMethodRenderer',
          pinned: 'left',
        },
      ]
    },

    getData(params) {
      const displayColumns = this.refreshColumns()
      params.api.setColumnDefs(displayColumns.columns)
      params.api.sizeColumnsToFit()
      params.api.setRowData(displayColumns.data)
      this.count = displayColumns.data.length
      this.loading = false
    },

    refreshColumns() {
      let displayColumns = this.columnDefs
      const data = []
      let assetClassObject = {}
      let percentage = {}
      let assetClasses = {}
      this.data.forEach(element => {
        assetClassObject = {}
        percentage = {}
        assetClasses = {}
        const details = element.filter(i => i.estimateMethod === this.type)
        details.forEach(assetClass => {
          const isPresent = displayColumns.some(
            i =>
              i.field === assetClass.assetClass &&
              i.headerComponentParams &&
              i.headerComponentParams.life === assetClass.life,
          )
          if (!isPresent) {
            displayColumns.push({
              field: assetClass.assetClass,
              headerClass: 'header-right',
              cellStyle: { textAlign: 'right' },
              headerComponent: 'headerRenderer',
              headerComponentParams: {
                life: assetClass.life,
              },
              width: 120,
              cellRenderer: 'estimateInfoRenderer',
              life: assetClass.life,
            })
          }
          Object.assign(percentage, {
            [assetClass.assetClass]: assetClass.percentage,
          })
          Object.assign(assetClasses, {
            [assetClass.assetClass]: assetClass.allocatedCost,
          })
          Object.assign(assetClassObject, {
            estimateGroupName: assetClass.estimateGroupName,
            estimateMethod: assetClass.estimateMethod
              ? assetClass.estimateMethod
              : this.estimateMethod,
            residualPercentage: assetClass.estimatePercentage,
            percentage: { ...percentage },
            assetClass: { ...assetClasses },
          })
        })
        if (details.length > 0) {
          assetClassObject = { ...assetClassObject }
          data.push(assetClassObject)
        }
      })
      displayColumns = _.sortBy(displayColumns, ['life'])
      return { columns: displayColumns, data: data }
    },
  },
}
